import { type Aal, aalSchema } from '@noconflict/contracts';
import type { Session } from '@supabase/supabase-js';
import { z } from 'zod';

const claimsSchema = z.object({ aal: aalSchema });

/**
 * The session's assurance level, read synchronously from the access token's `aal` claim (what supabase-js's
 * `getAuthenticatorAssuranceLevel` reports as `currentLevel`). Null without a session or a readable claim. It only
 * decides what the browser shows: every staff call still needs `aal2` in SQL.
 */
export function sessionAal(session: Session | null): Aal | null {
  const payload = session?.access_token.split('.')[1];
  if (!payload) return null;
  try {
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
    const parsed = claimsSchema.safeParse(JSON.parse(new TextDecoder().decode(bytes)));
    return parsed.success ? parsed.data.aal : null;
  } catch {
    return null;
  }
}
